/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PerplayStatisticsControllerDtoNftBoxRequest model module.
 * @module model/PerplayStatisticsControllerDtoNftBoxRequest
 * @version 1.0
 */
class PerplayStatisticsControllerDtoNftBoxRequest {
    /**
     * Constructs a new <code>PerplayStatisticsControllerDtoNftBoxRequest</code>.
     * @alias module:model/PerplayStatisticsControllerDtoNftBoxRequest
     * @param beginDate {Date} 
     * @param endDate {Date} 
     */
    constructor(beginDate, endDate) { 
        
        PerplayStatisticsControllerDtoNftBoxRequest.initialize(this, beginDate, endDate);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, beginDate, endDate) { 
        obj['beginDate'] = beginDate;
        obj['endDate'] = endDate;
    }

    /**
     * Constructs a <code>PerplayStatisticsControllerDtoNftBoxRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PerplayStatisticsControllerDtoNftBoxRequest} obj Optional instance to populate.
     * @return {module:model/PerplayStatisticsControllerDtoNftBoxRequest} The populated <code>PerplayStatisticsControllerDtoNftBoxRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PerplayStatisticsControllerDtoNftBoxRequest();

            if (data.hasOwnProperty('beginDate')) {
                obj['beginDate'] = ApiClient.convertToType(data['beginDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('boxType')) {
                obj['boxType'] = ApiClient.convertToType(data['boxType'], 'String');
            }
            if (data.hasOwnProperty('boxGrade')) {
                obj['boxGrade'] = ApiClient.convertToType(data['boxGrade'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PerplayStatisticsControllerDtoNftBoxRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PerplayStatisticsControllerDtoNftBoxRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of PerplayStatisticsControllerDtoNftBoxRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['boxType'] && !(typeof data['boxType'] === 'string' || data['boxType'] instanceof String)) {
            throw new Error("Expected the field `boxType` to be a primitive type in the JSON string but got " + data['boxType']);
        }
        // ensure the json data is a string
        if (data['boxGrade'] && !(typeof data['boxGrade'] === 'string' || data['boxGrade'] instanceof String)) {
            throw new Error("Expected the field `boxGrade` to be a primitive type in the JSON string but got " + data['boxGrade']);
        }

        return true;
    }


}

PerplayStatisticsControllerDtoNftBoxRequest.RequiredProperties = ["beginDate", "endDate"];

/**
 * @member {Date} beginDate
 */
PerplayStatisticsControllerDtoNftBoxRequest.prototype['beginDate'] = undefined;

/**
 * @member {Date} endDate
 */
PerplayStatisticsControllerDtoNftBoxRequest.prototype['endDate'] = undefined;

/**
 * @member {String} boxType
 */
PerplayStatisticsControllerDtoNftBoxRequest.prototype['boxType'] = undefined;

/**
 * @member {String} boxGrade
 */
PerplayStatisticsControllerDtoNftBoxRequest.prototype['boxGrade'] = undefined;






export default PerplayStatisticsControllerDtoNftBoxRequest;

